const socketApi = process.env.VUE_APP_SOCKET_API
import { v4 as uuidv4 } from 'uuid';
import checkPermission from '@/utils/permission'
import { eduPermissionOptions } from '@/utils/define'
// 缓存路由里的 params
export const routeParams = {
  data() {
    return {
      $params: {}
    }
  },
  created() {
    const { params, name } = this.$route
    const key = `router:${name}`
    if (JSON.stringify(params) !== '{}') {
      sessionStorage.setItem(key, JSON.stringify(params))
      this.$params = params
    } else {
      this.$params = JSON.parse(sessionStorage.getItem(key))
    }
  },
  beforeDestroy() {
    const { name } = this.$route
    const key = `router:${name}`
    sessionStorage.removeItem(key)
  }
}

// 教育机构服务 类型 (学历-专业, 非学历-产品)
export const educationalType = {
  data() {
    return {
      $showEdu: true,
      $eduType: ''
    }
  },
  created() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
    const { secondaryType } = userInfo
    if (secondaryType === "ACADEMIC_EDUCATION") {
      this.$showEdu = checkPermission(eduPermissionOptions)
      this.$eduType = '专业'
    }
    if (secondaryType === "NON_ACADEMIC_EDUCATION")  {
      this.$showEdu = true
      this.$eduType = '产品'
    }
  }
}

export const webSocketMixin = {
  data() {
    return {
      _socket: null,
      _socketId: null,
    }
  },
  methods: {
    _initSocket() {
      this._closeSocket()
      const id = uuidv4()
      this._socketId = id
      console.log(id)
      // this.codeId = `https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=3&query=${encodeURIComponent('id='+id)}`
      //  id
      // console.log(this.codeId)
      const socket = new WebSocket(`${socketApi}/consumer/webSocket/getLink/${id}`)
      socket.onopen = (e) => {
        console.log('socket open: ', e)
      }
      this._socket = socket
    },
    _closeSocket() {
      if (this._socket) {
        this._socket.close()
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/mixins.js